/**
 * Adds a prefix to every property key in an object
 *
 * @param obj - The object whose properties will be prefixed
 * @param prefix - The prefix to add to each property key
 * @returns A new object with prefixed property keys
 */
export const addPrefixToObjectProperties = <T extends Record<string, any>>(
  obj: T,
  prefix: string
): Record<string, any> => {
  if (!obj || Object.keys(obj).length === 0) {
    return {};
  }

  return Object.entries(obj).reduce(
    (result, [key, value]) => {
      result[`${prefix}${key}`] = value;
      return result;
    },
    {} as Record<string, any>
  );
};
